import { ContainerBadgeComponent } from '@modules/common/components/container-badge/container-badge.component';
import { DetailBreadcrumbsComponent } from '@modules/common/components/detail-breadcrumbs/detail-breadcrumbs.component';
import { ItemReviewComponent } from '@modules/common/components/item-review/item-review.component';
import { ItemHandoverComponent } from '@modules/common/components/item-handover/item-handover.component';
import { CanPurgeTeamItemPipe } from '@modules/common/pipes/can-purge-team-item.pipe';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { StitchTimestampsComponent } from '@modules/common/components/stitch-timestamps/stitch-timestamps.component';
import { CommonModule as AngularCommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommentsModule } from '@modules/comments/comments.module';
import { CommonModule } from '@modules/common/common.module';
import { ListItemSeparatorComponent } from '@modules/common/components/list/list-items-separator/list-items-separator.component';
import { ListLoadErrorComponent } from '@modules/common/components/list/list-load-error/list-load-error.component';
import { Button2Component } from '@frontendlib/components/components/button/button2.component';
import { ContextMenuDividerComponent } from '@frontendlib/components/features/popover/components/context-menu-divider/context-menu-divider.component';
import { ContextMenuHeadingComponent } from '@frontendlib/components/features/popover/components/context-menu-heading/context-menu-heading.component';
import { ContextMenuItemComponent } from '@frontendlib/components/features/popover/components/context-menu-item/context-menu-item.component';
import { ContextMenuStateIndicatorComponent } from '@frontendlib/components/features/popover/components/context-menu-state-indicator/context-menu-state-indicator.component';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { LoadingIndicatorComponent } from '@frontendlib/components/components/loading-indicator/loading-indicator.component';
import { NoContentStubComponent } from '@frontendlib/components/components/no-content-stub/no-content-stub.component';
import { PopoverDirective } from '@frontendlib/components/features/popover/directives/popover.directive';
import { SearchLocationBadgeComponent } from '@frontendlib/components/components/search-location-badge/search-location-badge.component';
import { ListSelectionBarComponent } from '@modules/common/components/list/list-selection-bar/list-selection-bar.component';
import { Pagination2Component } from '@modules/common/components/pagination/pagination2.component';
import { SidebarItemComponent } from '@modules/common/components/sidebar-item/sidebar-item.component';
import { ConnectionsModule } from '@modules/connections/connections.module';
import { ContactsModule } from '@modules/contacts/contacts.module';
import { DragNDropModule } from '@modules/drag-n-drop/drag-n-drop.module';
import { LinkedInfoListComponent } from '@modules/elements/components/link-info/linked-info-list/linked-info-list.component';
import { EntityHubSearchComponent } from '@modules/elements/components/entity-hub/entity-hub-search/entity-hub-search.component';
import { StitchHubComponent } from '@modules/elements/components/stitch-hub/stitch-hub.component';
import { FolderQuickFormComponent } from '@modules/elements/components/quick-forms/folder-quick-form/folder-quick-form.component';
import { FileContextMenuDirective } from '@modules/elements/directives/file-context-menu.directive';
import { FolderContextMenuDirective } from '@modules/elements/directives/folder-context-menu.directive';
import { ElementsModule } from '@modules/elements/elements.module';
import { FilesSideBarComponent } from '@modules/files/components/side-bar/side-bar.component';
import { TitleByFilesFilterPipe } from '@modules/files/pipes/title-by-files-filter.pipe';
import { QuickActionComponent } from '@modules/form-controls/components/quick-action/quick-action.component';
import { ItemDescriptionFieldComponent } from '@modules/common/components/item-description/item-description-field.component';
import { FormControlsModule } from '@modules/form-controls/form-controls.module';
import { MatIconModule } from '@angular/material/icon';
import { KnotsModule } from '@modules/knots/knots.module';
import { ScrollModule } from '@modules/scroll/scroll.module';
import { TagsModule } from '@modules/tags/tags.module';
import { ToArrayPipe } from '@modules/utils/pipes/array/to-array.pipe';
import { FileSizePipe } from '@modules/utils/pipes/file/file-size.pipe';
import { UtilsModule } from '@modules/utils/utils.module';
import { FileFormComponent } from './components/file-form/file-form.component';
import { FilePreviewComponent } from './components/file-preview/file-preview.component';
import { FilesListContextMenuComponent } from './components/files-list-context-menu/files-list-context-menu.component';
import { FilesListComponent } from './components/files-list/files-list.component';
import { FilesMainViewComponent } from './components/files-main-view/files-main-view.component';
import { FolderFormComponent } from './components/folder-form/folder-form.component';
import { FolderSectionsComponent } from './components/folder-sections/folder-sections.component';
import { FoldersListContextMenuComponent } from './components/folders-list-context-menu/folders-list-context-menu.component';
import { FoldersListComponent } from './components/folders-list/folders-list.component';
import { FilesListContainerComponent } from './components/list-container/list-container.component';
import { SideBarFoldersTreeComponent } from './components/side-bar-folders-tree/side-bar-folders-tree.component';
import { SideBarFoldersComponent } from './components/side-bar-folders/side-bar-folders.component';
import { SidebarContextMenuComponent } from './components/sidebar-context-menu/sidebar-context-menu.component';
import { FilesListContextMenuDirective } from './directives/files-list-context-menu.directive';
import { FoldersListContextMenuDirective } from './directives/folders-list-context-menu.directive';
import { SidebarContextMenuDirective } from './directives/sidebar-context-menu.directive';
import { KnowledgeHubComponent } from '../knowledge/components/knowledge-hub/knowledge-hub.component';
import { FeatureUpsellComponent } from '../common/components/feature-upsell/feature-upsell.component';
import { TenancySelectorComponent } from '../common/components/tenancy-selector/tenancy-selector.component';

@NgModule({
  imports: [
    ContainerBadgeComponent,
    DetailBreadcrumbsComponent,
    ItemHandoverComponent,
    ItemReviewComponent,
    CanPurgeTeamItemPipe,
    SearchLocationBadgeComponent,
    AngularCommonModule,
    CommentsModule,
    CommonModule,
    ConnectionsModule,
    DragNDropModule,
    ElementsModule,
    FormControlsModule,
    FormsModule,
    KnotsModule,
    MatIconModule,
    MatTooltipModule,
    ContextMenuDividerComponent,
    ContextMenuHeadingComponent,
    ContextMenuItemComponent,
    ContextMenuStateIndicatorComponent,
    PopoverDirective,
    ReactiveFormsModule,
    ScrollModule,
    ScrollingModule,
    TagsModule,
    UtilsModule,
    ListLoadErrorComponent,
    NoContentStubComponent,
    LoadingIndicatorComponent,
    ListItemSeparatorComponent,
    ListSelectionBarComponent,
    Pagination2Component,
    QuickActionComponent,
    ItemDescriptionFieldComponent,
    ToArrayPipe,
    ContactsModule,
    FilePreviewComponent,
    FolderContextMenuDirective,
    FileContextMenuDirective,
    LinkedInfoListComponent,
    EntityHubSearchComponent,
    StitchHubComponent,
    FolderQuickFormComponent,
    SidebarItemComponent,
    FilesListComponent,
    KnowledgeHubComponent,
    FeatureUpsellComponent,
    Button2Component,
    IconComponent,
    StitchTimestampsComponent,
    FileSizePipe,
    TenancySelectorComponent,
  ],
  declarations: [
    // Components
    FileFormComponent,
    FilesListContainerComponent,
    FilesListContextMenuComponent,
    FilesMainViewComponent,
    FilesSideBarComponent,
    FolderFormComponent,
    FolderSectionsComponent,
    FoldersListComponent,
    FoldersListContextMenuComponent,
    SideBarFoldersComponent,
    SideBarFoldersTreeComponent,
    SidebarContextMenuComponent,
    // Directives
    FoldersListContextMenuDirective,
    FilesListContextMenuDirective,
    SidebarContextMenuDirective,
    // Pipes
    TitleByFilesFilterPipe,
  ],
  exports: [
    // Components
    FileFormComponent,
    FilesListComponent,
    FilesListContainerComponent,
    FilesListContextMenuComponent,
    FilesMainViewComponent,
    FilesSideBarComponent,
    FolderFormComponent,
    FoldersListComponent,
    FoldersListContextMenuComponent,
    // Directives
    FoldersListContextMenuDirective,
    FilesListContextMenuDirective,
    // Pipes
    TitleByFilesFilterPipe,
  ],
  providers: [],
})
export class FilesModule {}
